import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge(example, pageable);
    return httpService.get("/tenant", {params: params});
  },

  findById(id) {
    return httpService.get(`/tenant/${id}`);
  },
  findByCode(code) {
    return httpService.get(`/tenant/findByCode/${code}`);
  },
  count(example) {
    return httpService.get("tenant/count", {params: example});
  },
  deactiveTenant(tenantId) {
    return httpService.get(`tenant/${tenantId}/deactive`);
  },
  activeTenant(tenantId) {
    return httpService.get(`tenant/${tenantId}/active`);
  },
  getTenantServices(tenantId) {
    return httpService.get(`tenant/${tenantId}/getServices`);
  },
  createTenant(tenant){
      return httpService.post("/tenant",tenant)
  },
  updateTenant(tenantId,tenant){
      return httpService.put(`tenant/${tenantId}`,tenant)
  },
  getTenantServiceStatus(serviceCode) {
    return httpService.get(`tenant/getTenantServiceStatus/${serviceCode}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/tenantService.js